import { createEffect } from '@databases/selections';
import { type SelectionsApi } from '@databases/selections-api';

interface CellPosition {
  row: { index: number };
  col: { index: number };
}

interface CellEditingEffectDeps {
  selectionsApi: SelectionsApi;
  notifyCellEditing: (entryId: string, fieldId: string, editing: boolean) => void;
}

export const createCellEditingEffect = createEffect(
  ({ selectionsApi, notifyCellEditing }: CellEditingEffectDeps) => {
    let isOpen = false;
    let openPosition: CellPosition | undefined;

    const getCellIds = (position: CellPosition) =>
      selectionsApi.resolvePositionToIds(position, 'cell');

    const setCellEditingState = (position: CellPosition, editing: boolean) => {
      const { entryId, fieldId } = getCellIds(position);

      if (entryId && fieldId) {
        notifyCellEditing(entryId, fieldId, editing);
      }
    };

    return {
      dispose() {
        if (isOpen && openPosition) {
          setCellEditingState(openPosition, false);
        }

        isOpen = false;
        openPosition = undefined;
      },

      deltaTypes: ['cellEditRequested', 'cellEditStopped'],

      onDelta(delta) {
        if (delta.kind === 'cellEditRequested') {
          const { entryId, fieldId } = getCellIds(delta.position);

          if (!fieldId || !entryId) {
            return;
          }

          setCellEditingState(delta.position, true);

          isOpen = true;
          openPosition = delta.position;
        } else if (delta.kind === 'cellEditStopped') {
          if (isOpen && openPosition) {
            setCellEditingState(openPosition, false);
          }

          isOpen = false;
          openPosition = undefined;
        }
      },
    };
  }
);
